import {
	MONTH_OFFSET_20,
	MONTH_OFFSET_50,
	MONTH_OFFSET_70,
	YEAR_THRESHOLD,
} from '../../const/zod/zod';

export const getCountedMonth = (
	rawMonth: number,
	countedYear: number,
): number => {
	const isMonthGreaterThan70 = rawMonth > MONTH_OFFSET_70;
	const isMonthGreaterThan50 = rawMonth > MONTH_OFFSET_50;
	const isMonthGreaterThan20 = rawMonth > MONTH_OFFSET_20;

	const isCountedYearOverThreshold = countedYear > YEAR_THRESHOLD;

	const shouldSubtract70 = isMonthGreaterThan70 && isCountedYearOverThreshold;
	const shouldSubtract20 = isMonthGreaterThan20 && isCountedYearOverThreshold;

	if (shouldSubtract70) {
		return rawMonth - MONTH_OFFSET_70;
	}

	if (isMonthGreaterThan50) {
		return rawMonth - MONTH_OFFSET_50;
	}

	if (shouldSubtract20) {
		return rawMonth - MONTH_OFFSET_20;
	}

	return rawMonth;
};
